import styled from "@emotion/styled";
import { SidebarNav } from "../SidebarNav";
import { usePageTitle } from "src/Common/hooks/usePageTitle";

interface Props {
  children: React.ReactNode;
}

export const Layout = ({ children }: Props) => {
  usePageTitle();
  return (
    <Container>
      <SidebarNav />
      <Content>{children}</Content>
      v.1
    </Container>
  );
};

const Container = styled.div({
  width: "100vw",
  height: "100vh",
  display: "grid",
  // `minmax(0, 1fr)` (not the default `1fr`, whose implied minimum is
  // `min-content`) lets the content track shrink to its grid cell. Without
  // it, a wide child (e.g. the opener table) expands the track past its
  // share and blows the grid wider than 100vw, scrolling the whole page
  // horizontally and clipping the left edge.
  gridTemplateColumns: "40px minmax(0, 1fr)",
});

const Content = styled.div({
  minWidth: 0,
  overflowY: "auto",
});
